// @services
import { xervixApi } from '../config/axios.config';

// @constants
import { API_ROUTES } from '../constants/apiRoutes';

// @types
import { ApiResponse, ICities, IDepartments } from '../types/locations.types';


const getAllDepartments = async (): Promise<ApiResponse<IDepartments[]>> => {
    try {
        const response = await xervixApi.get(API_ROUTES.LOCATIONS.DEPARTMENTS);
        return response;
    } catch (error: any) {
        throw error;
    }
};

const getCityByDepartment = async (departmentId: number): Promise<ApiResponse<ICities[]>> => {
    try {
        const response = await xervixApi.get(API_ROUTES.LOCATIONS.CITIES(departmentId));
        return response;
    } catch (error: any) {
        throw error;
    }
};


const methodsRequest = {
    getAllDepartments,
    getCityByDepartment,
};

export default methodsRequest;
